"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("./react");

var useMedia = function useMedia(query) {
  var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _react_1$useState = react_1.useState(defaultState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  react_1.useEffect(function () {
    var mounted = true;
    var mql = window.matchMedia(query);

    var onChange = function onChange() {
      if (!mounted) return;
      setState(!!mql.matches);
    };

    mql.addListener(onChange);
    setState(mql.matches);
    return function () {
      mounted = false;
      mql.removeListener(onChange);
    };
  }, [query]);
  return state;
};

exports.default = useMedia;